import { render, staticRenderFns } from "./programEdit.vue?vue&type=template&id=8ebca4d0&scoped=true"
import script from "./programEdit.vue?vue&type=script&lang=js"
export * from "./programEdit.vue?vue&type=script&lang=js"
import style0 from "./programEdit.vue?vue&type=style&index=0&id=8ebca4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebca4d0",
  null
  
)

export default component.exports